var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solution-preview"},_vm._l((_vm.solution.sequencePreview),function(acid,seqNum){return _c('div',{key:`preview-acid-${seqNum}`,staticClass:"preview-acid",class:{ insert: _vm.isInsert(acid), scaffold: _vm.isScaffold(acid) }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }